///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export class ValidationAlertModel {
    text: string;
    params?: Record<string, string>;
    type?: ValidationAlertType;
}

export enum ValidationAlertType {
    DANGER = 'alert-danger',
    WARNING = 'alert-warning',
    SUCCESS = 'alert-success'
}
